const CustomDatapicker = {
  custom: 'Rango Personalizado',
  custom_medium: 'Otro',
  shortcuts: {
    text: {
      'week': 'Semana',
      '1month': '1 mes',
      '3months': '3 meses'
    },
    text_short: {
      'week': '7d',
      '1month': '1m',
      '3months': '3m'
    }
  },
  tooltips: {
    'custom': 'Rango Personalizado',
    'week': 'Semana',
    '1month': '1 mes',
    '3months': '3 meses'
  },
};

export default CustomDatapicker;
